import React from "react";
import styles from "./page1.scss";
import pic from "./pic.png";

function Page1(props) {
  return (
    <div className={styles.page1} ref={props.myRef}>
      <div className={styles["page1-main"]}>
        <div className={styles["page1-left"]}></div>

        <div className={`${styles["page1-title"]} animate2-wrapper`}>
          <div
            r="231"
            g="232"
            b="244"
            className={`maskBlock animate2`}
            style={{ background: "rgb(231, 232, 244)" }}
          />
          INTRODUCTION
        </div>

        <div className={styles["page1-area"]}></div>

        <div className={styles["page1-pic"]}>
          {/* <img src={pic} /> */}
          <video
            controls="controls"
            muted
            autoplay="autoplay"
            className={styles.video}
          >
            <source
              src="https://statics.wow-trend.com/wow-trend-cn/video/wowtrend.mp4"
              type="video/mp4"
            />
          </video>
          <a
            href="https://beian.miit.gov.cn/"
            className={styles["page1-beian"]}
          >
            粤ICP备15020968号
          </a>
        </div>

        <div className={styles["page1-content"]}>
          <div className={styles["page1-content-number"]}>1</div>

          <div className={styles["page1-content-line"]}></div>

          <div className={styles["page1-content-title"]}>品牌介绍</div>

          <div className={`${styles["page1-content-text"]} animate1-wrapper`}>
            <div
              r="231"
              g="232"
              b="244"
              className={`maskBlock animate1`}
              style={{ background: "rgb(231, 232, 244)" }}
            />
            深圳市星潮热点传播股份有限公司（以下简称WOW-TREND热点趋势）是立足中国时尚产业的垂直服务平台，于2014年在深圳成立。
            <br />
            <br />
            我们拥有国内外权威的创意设计和数据分析团队，专注于洞察与引领未来趋势，协助企业与供应链之间的交流，并致力构建行业网络。
            <br />
            <br />
            我们多维度提供“趋势预测”、“策略教育”、“设计定制”等垂直服务，助力企业落地化运用趋势、把握中国市场的创新和发展机遇。
            {/* <div className={`${styles.maskBlock} animate1`} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;
